import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';

import { FulfillmentExportMessages } from './messages/fulfillment-export-messages';
import { ExportOptions, ExportOptionsValues } from '../export-records-modal/enums/export-options-enum';

import style from './style.module.less';
import { emptyArray } from 'ui-components/default-props/empty';
import { CustomExportsContainer } from '../export-records-modal/containers/custom-exports-container';
import { ExportOptionSelectionModalView } from '../export-records-modal/components/option-selection-modal-view';

const OPTION_SELECTION_VIEW = 'OPTION_SELECTION_VIEW';
const UPDATE_FORMAT_VIEW = 'UPDATE_FORMAT_VIEW';

const getMessages = (recordExportType) => {
  if (recordExportType === ExportOptions.FULFILLMENT_RECORD_EXPORT) {
    return FulfillmentExportMessages;
  }
};

export const ExportRecordsModal = ({
  exportFormats = emptyArray,
  onClose,
  onDeleteExportFormat,
  onExport,
  onExportTypeChanged,
  onFormatTypeChanged,
  onSaveExportFormat,
  primaryRecordsOrLineItems,
  selectedExportFormatTypeId,
  recordExportType,
  selectedCount = 0,
  viewCount = 0,
}) => {
  const [currentView, setView] = useState(OPTION_SELECTION_VIEW);
  const setViewToUpdate = useCallback(() => setView(UPDATE_FORMAT_VIEW), [setView]);
  const [formatToEdit, setFormatToEdit] = useState({});

  const onEditFormat = useCallback(
    (format) => {
      setFormatToEdit(format);
      setViewToUpdate();
    },
    [setFormatToEdit, setViewToUpdate],
  );

  const setViewToOptionSelection = useCallback(() => {
    setView(OPTION_SELECTION_VIEW);
    setFormatToEdit({});
  }, [setView, setFormatToEdit]);
  // BXY - only one export type has messages. I have no idea why no other types have them.
  const messages = getMessages(recordExportType) || FulfillmentExportMessages;

  return (
    <Modal className={style['export-records-modal']}>
      <ModalHeader closeModal={onClose}>
        <FormattedMessage {...messages.modalTitle} />
      </ModalHeader>
      {(currentView === OPTION_SELECTION_VIEW && (
        <ExportOptionSelectionModalView
          closeModal={onClose}
          exportFormats={exportFormats}
          messages={messages}
          numberRecordsInView={viewCount}
          numberRecordsSelected={selectedCount}
          onDeleteExportFormat={onDeleteExportFormat}
          onEditFormat={onEditFormat}
          onExportRecordTypeChanged={onExportTypeChanged}
          onFormatTypeChanged={onFormatTypeChanged}
          onInitiateExport={onExport}
          primaryRecordsOrLineItems={primaryRecordsOrLineItems}
          recordExportType={recordExportType}
          selectedExportFormatTypeId={selectedExportFormatTypeId}
          setViewToUpdate={setViewToUpdate}
        />
      )) ||
        (currentView === UPDATE_FORMAT_VIEW && (
          <CustomExportsContainer
            closeModal={onClose}
            formatId={formatToEdit.extractId}
            formatName={formatToEdit.name}
            onGoBack={setViewToOptionSelection}
            onSaveExportFormat={onSaveExportFormat}
            primaryRecordsOrLineItems={primaryRecordsOrLineItems}
            recordExportType={recordExportType}
          />
        ))}
    </Modal>
  );
};

ExportRecordsModal.propTypes = {
  exportFormats: PropTypes.array,
  onClose: PropTypes.func.isRequired,
  onDeleteExportFormat: PropTypes.func.isRequired,
  onExport: PropTypes.func.isRequired,
  onExportTypeChanged: PropTypes.func.isRequired,
  onFormatTypeChanged: PropTypes.func.isRequired,
  onSaveExportFormat: PropTypes.func.isRequired,
  primaryRecordsOrLineItems: PropTypes.string.isRequired,
  selectedExportFormatTypeId: PropTypes.string.isRequired,
  recordExportType: PropTypes.oneOf(ExportOptionsValues).isRequired,
  selectedCount: PropTypes.number,
  viewCount: PropTypes.number,
};
